

import { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

// Company
import CompanyIndex from './components/pages/company/Index';
import CompanyCreate from "./components/pages/company/Create";
import CompanyEdit from "./components/pages/company/Edit";
// Item
import ItemIndex from './components/pages/Item/Index';
import ItemCreate from "./components/pages/Item/Create";
import ItemEdit from "./components/pages/Item/Edit";
import ItemDetail from "./components/pages/Item/Detail";
// Table Name
import TableNameIndex from './components/pages/TableName/Index';
import TableNameCreate from "./components/pages/TableName/Create";
import TableNameEdit from "./components/pages/TableName/Edit";
// KOT
import KOTCreate from "./components/pages/KOT/Create";
import KOTEdit from "./components/pages/KOT/Edit";
//Sale
import SaleIndex from './components/pages/Sale/Index';
import SaleEdit from "./components/pages/Sale/Edit";
import BillPrint from "./components/pages/Sale/Bill";
import SaleDetail from "./components/pages/Sale/Detail";


//User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";
//Report
import SaleRegister from "./components/pages/Report/SaleRegister";
import SalePayment from "./components/pages/Report/SalePayment";
import SaleGST from "./components/pages/Report/SaleGST";
import SaleEditDetails from "./components/pages/Report/SaleEditDetails";


import Home from "./components/pages/Home";
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import { AuthProvider, useAuth } from "./AuthContext";
import Logout from "./Logout";
import SessionTimeout from "./SessionTimeout";

import InventoryIcon from '@mui/icons-material/Inventory';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import StoreIcon from '@mui/icons-material/Store';
import CategoryIcon from '@mui/icons-material/Category';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ArticleIcon from '@mui/icons-material/Article';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import EditNoteIcon from '@mui/icons-material/EditNote';

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };


  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };

  const handleItemClick = () => {
    setItemOpen(!itemOpen);
  };




  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName } = useAuth();

  return (
    <Router>
      <AuthProvider>
        <SessionTimeout />
        <AppBar 
          position="static" 
          style={{ 
            background: '#0f172a',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
            borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
            zIndex: 1100
          }}
        >
          <Toolbar style={{ minHeight: '64px', padding: '0 24px' }}>
            <IconButton 
              edge="start" 
              color="inherit" 
              aria-label="menu" 
              onClick={handleDrawerOpen}
              style={{
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid rgba(255, 255, 255, 0.05)',
                transition: 'all 0.3s ease',
                borderRadius: '10px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.08)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.05)';
              }}
            >
              <MenuIcon style={{ color: '#cbd5e1' }} />
            </IconButton>
            <div 
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between', 
                width: '100%',
                marginLeft: '20px'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Link 
                  to="/Home" 
                  style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
                >
                  <Typography 
                    variant="subtitle1" 
                    component="div" 
                    style={{ 
                      fontWeight: '600',
                      color: '#38bdf8', /* Default accent color */
                      letterSpacing: '1px',
                      fontSize: '16px',
                      textTransform: 'uppercase',
                      transition: 'color 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = '#7dd3fc'; /* Lighter blue on hover */
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = '#38bdf8';
                    }}
                  >
                    {companyName}
                  </Typography>
                </Link>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Logout />
              </div>
            </div>
          </Toolbar>
        </AppBar>
        {roleName !== "Counter" && (
          <Drawer 
            anchor="left" 
            open={drawerOpen} 
            onClose={handleDrawerClose}
            PaperProps={{
              style: {
                background: '#0f172a',
                color: '#f8fafc',
                width: '280px',
                boxShadow: '4px 0 24px rgba(0, 0, 0, 0.4)',
                borderRight: '1px solid rgba(255, 255, 255, 0.05)'
              }
            }}
          >
            <style>
              {`
                .sidebar-item {
                  border-radius: 10px !important;
                  margin: 6px 16px !important;
                  transition: all 0.2s ease !important;
                  background: transparent !important;
                  color: #e2e8f0 !important;
                }
                .sidebar-item:hover {
                  background: rgba(255, 255, 255, 0.05) !important;
                }
                .sidebar-item.selected {
                  background: rgba(56, 189, 248, 0.1) !important;
                  color: #38bdf8 !important;
                }
                .sidebar-item.selected .MuiTypography-root {
                  color: #38bdf8 !important;
                }
                
                .sidebar-collapse-container {
                  margin: 2px 16px 12px 16px !important;
                  background: rgba(0, 0, 0, 0.2) !important;
                  border-radius: 10px !important;
                  border: 1px solid rgba(255, 255, 255, 0.02) !important;
                  padding: 6px 0 !important;
                }

                .sidebar-subitem {
                  border-radius: 8px !important;
                  margin: 2px 8px !important;
                  padding: 8px 12px !important;
                  color: #94a3b8 !important;
                  transition: all 0.2s ease !important;
                }
                .sidebar-subitem:hover {
                  background: rgba(255, 255, 255, 0.05) !important;
                  color: #f8fafc !important;
                }
                .sidebar-subitem.selected {
                  background: rgba(255, 255, 255, 0.03) !important;
                  color: #38bdf8 !important;
                }
                .sidebar-subitem.selected .MuiTypography-root {
                  color: #38bdf8 !important;
                  font-weight: 600 !important;
                }
                .sidebar-header-text {
                  font-weight: 600 !important;
                  letter-spacing: 0.5px !important;
                  font-size: 14px !important;
                }
                .sidebar-icon {
                  font-size: 20px !important;
                  margin-right: 12px !important;
                }
                .sidebar-header-icon {
                  font-size: 22px !important;
                  margin-right: 14px !important;
                  color: #64748b;
                  transition: color 0.2s ease;
                }
                .sidebar-item:hover .sidebar-header-icon {
                  color: #94a3b8;
                }
                .sidebar-item.selected .sidebar-header-icon {
                  color: #38bdf8;
                }
              `}
            </style>
            
            <div style={{ padding: '24px 20px 10px 20px', display: 'flex', alignItems: 'center' }}>
               <Typography variant="h6" style={{ fontWeight: 700, color: '#f8fafc', letterSpacing: '1px' }}>
                 MENU
               </Typography>
            </div>

            <List style={{ padding: '0 0 20px 0' }}>
              <ListItem 
                button 
                component={NavLink} 
                to="/Home" 
                activeClassName="selected" 
                onClick={handleDrawerClose}
                className="sidebar-item"
              >
                <FiHome className="sidebar-header-icon" />
                <ListItemText disableTypography primary={<Typography className="sidebar-header-text">HOME</Typography>} />
              </ListItem>

              <ListItem button onClick={handleMasterClick} className="sidebar-item">
                <StoreIcon className="sidebar-header-icon" />
                <ListItemText disableTypography primary={<Typography className="sidebar-header-text">MASTER</Typography>} />
                {masterOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={masterOpen} timeout="auto" unmountOnExit>
                <List className="sidebar-collapse-container">
                  <ListItem button component={NavLink} to="/CompanyIndex" activeClassName="selected" onClick={handleDrawerClose} className="sidebar-subitem">
                    <StoreIcon className="sidebar-icon" style={{ color: '#10b981' }} />
                    <ListItemText primary="Company" />
                  </ListItem>
                  <ListItem button component={NavLink} to="/ItemIndex" activeClassName="selected" onClick={handleDrawerClose} className="sidebar-subitem">
                    <CategoryIcon className="sidebar-icon" style={{ color: '#38bdf8' }} />
                    <ListItemText primary="Item" />
                  </ListItem>
                  <ListItem button component={NavLink} to="/TableNameIndex" activeClassName="selected" onClick={handleDrawerClose} className="sidebar-subitem">
                    <TableRestaurantIcon className="sidebar-icon" style={{ color: '#fbbf24' }} />
                    <ListItemText primary="Table" />
                  </ListItem>
                </List>
              </Collapse>

              <ListItem button onClick={handleItemClick} className="sidebar-item">
                <AddShoppingCartIcon className="sidebar-header-icon" />
                <ListItemText disableTypography primary={<Typography className="sidebar-header-text">SALE</Typography>} />
                {itemOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={itemOpen} timeout="auto" unmountOnExit>
                <List className="sidebar-collapse-container">
                  <ListItem button component={NavLink} to="/SaleIndex" activeClassName="selected" onClick={handleDrawerClose} className="sidebar-subitem">
                    <AddShoppingCartIcon className="sidebar-icon" style={{ color: '#f43f5e' }} />
                    <ListItemText primary="Sale" />
                  </ListItem>
                </List>
              </Collapse>

              <ListItem button onClick={handleReportClick} className="sidebar-item">
                <SummarizeIcon className="sidebar-header-icon" />
                <ListItemText disableTypography primary={<Typography className="sidebar-header-text">REPORT</Typography>} />
                {reportOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={reportOpen} timeout="auto" unmountOnExit>
                <List className="sidebar-collapse-container">
                  <ListItem button component={NavLink} to="/SaleRegister" activeClassName="selected" onClick={handleDrawerClose} className="sidebar-subitem">
                    <InventoryIcon className="sidebar-icon" style={{ color: '#10b981' }} />
                    <ListItemText primary="Sale Register" />
                  </ListItem>
                  <ListItem button component={NavLink} to="/SalePayment" activeClassName="selected" onClick={handleDrawerClose} className="sidebar-subitem">
                    <ArticleIcon className="sidebar-icon" style={{ color: '#fbbf24' }} />
                    <ListItemText primary="Sale Details" />
                  </ListItem>
                  <ListItem button component={NavLink} to="/SaleGST" activeClassName="selected" onClick={handleDrawerClose} className="sidebar-subitem">
                    <SummarizeIcon className="sidebar-icon" style={{ color: '#38bdf8' }} />
                    <ListItemText primary="Sale Register GST" />
                  </ListItem>
                  <ListItem button component={NavLink} to="/SaleEditDetails" activeClassName="selected" onClick={handleDrawerClose} className="sidebar-subitem">
                    <EditNoteIcon className="sidebar-icon" style={{ color: '#f43f5e' }} />
                    <ListItemText primary="Edited Bill Details" />
                  </ListItem>
                </List>
              </Collapse>

              <ListItem button onClick={handleUserClick} className="sidebar-item">
                <PeopleAltIcon className="sidebar-header-icon" />
                <ListItemText disableTypography primary={<Typography className="sidebar-header-text">USER</Typography>} />
                {userOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={userOpen} timeout="auto" unmountOnExit>
                <List className="sidebar-collapse-container">
                  <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" onClick={handleDrawerClose} className="sidebar-subitem">
                    <PeopleAltIcon className="sidebar-icon" style={{ color: '#10b981' }} />
                    <ListItemText primary="User" />
                  </ListItem>
                  {isSuperAdmin && companyId == superCompanyId && (
                    <ListItem button component={NavLink} to="/RoleIndex" activeClassName="selected" onClick={handleDrawerClose} className="sidebar-subitem">
                      <AccessibilityIcon className="sidebar-icon" style={{ color: '#fbbf24' }} />
                      <ListItemText primary="Role" />
                    </ListItem>
                  )}
                  <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose} className="sidebar-subitem">
                    <SecurityIcon className="sidebar-icon" style={{ color: '#38bdf8' }} />
                    <ListItemText primary="Change Password" />
                  </ListItem>
                </List>
              </Collapse>
            </List>
          </Drawer>
        )}


        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/Home" exact component={Home} />

          {/* Company */}
          <Route path="/CompanyIndex" component={CompanyIndex} />
          <Route path="/CompanyCreate" component={CompanyCreate} />
          <Route path="/CompanyEdit/:id" component={CompanyEdit} />

          {/* Item */}
          <Route path="/ItemIndex" component={ItemIndex} />
          <Route path="/ItemCreate" component={ItemCreate} />
          <Route path="/ItemEdit/:id" component={ItemEdit} />
          <Route path="/ItemDetail/:id" component={ItemDetail} />
          {/* TableName */}
          <Route path="/tableNameIndex" component={TableNameIndex} />
          <Route path="/tableNameCreate" component={TableNameCreate} />
          <Route path="/tableNameEdit/:id" component={TableNameEdit} />
          {/* KOT */}
          <Route path="/kotCreate/:id" component={KOTCreate} />
          <Route path="/kotEdit/:id" component={KOTEdit} />
          {/* Sale */}
          <Route path="/saleIndex" component={SaleIndex} />
          <Route path="/saleEdit/:id" component={SaleEdit} />
          <Route path="/billPrint/:id" component={BillPrint} />
          <Route path="/SaleDetail/:id" component={SaleDetail} />

          {/* User */}
          <Route path="/UserIndex" component={UserIndex} />
          <Route path="/UserCreate" component={UserCreate} />
          <Route path="/UserEdit/:id" component={UserEdit} />
          <Route path="/UserDetail/:id" component={UserDetail} />
          <Route path="/PasswordChange" component={PasswordChange} />
          {/* Role */}
          <Route path="/RoleIndex" component={RoleIndex} />
          <Route path="/RoleDetail/:id" component={RoleDetail} />
          {/* Report */}
          <Route path="/SaleRegister" component={SaleRegister} />
          <Route path="/SalePayment" component={SalePayment} />
          <Route path="/SaleGST" component={SaleGST} />
          <Route path="/SaleEditDetails" component={SaleEditDetails} />

          {/* Add your other routes here */}
        </Switch>
      </AuthProvider >
    </Router>
  );
};

export default App;

